import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';

const templateService = {
  createTemplate: async (data: any): Promise<any> => {
    const result = await httpClient.post<any>('/api-web/v1/main/save_template', data);

    return result;
  },
  getTemplates: async (): Promise<any> => {
    const result = await httpClient.post<any>('/api-web/v1/main/get_templates', {
      limit: '30',
      offset: '0',
    });

    return result;
  },
  deleteTemplate: async (data: any) => {
    const result = await httpClient.post<any>('/api-web/v1/main/edit_template', data);

    return result;
  },

  changeNameTemplate: async (data: any) => {
    const result = await httpClient.post<any>('/api-web/v1/main/edit_template', data);

    return result;
  },

  filterTemplate: async (data: any) => {
    const result = await httpClient.post<any>('/api-web/v1/main/get_templates', data);

    return result;
  },

  editTemplate: async (data: any) => {
    const result = await httpClient.post<any>('/api-web/v1/main/edit_template', data);

    return result;
  },
};

export const useCreateTemplateService = () => {
  const {
    isLoading: isLoadingCreateTemplate,
    mutate: createTemplateMutation,
    data: dataCreateTemplate,
  } = useMutation('createTemplate', (data: any) => templateService.createTemplate(data));

  return {
    isLoadingCreateTemplate,
    createTemplateMutation,
    dataCreateTemplate,
  };
};

export const useGetTemplates = () => {
  const {
    isLoading: isLoadingGetTemplates,
    data: dataGetTemplates,
    refetch: refetchGetTemplate,
  } = useQuery('getTemplate', templateService.getTemplates, { enabled: false });

  return { isLoadingGetTemplates, refetchGetTemplate, dataGetTemplates };
};

export const useDeleteTemplate = (isEdit: boolean) => {
  const { refetchGetTemplate } = useGetTemplates();

  const {
    isLoading: isLoadingDeleteTemplate,
    mutate: deleteTemplateMutation,
    data: dataDeleteTemplate,
  } = useMutation('deleteTemplate', (data: any) => templateService.deleteTemplate(data), {
    onSuccess: () => {
      if (!isEdit) {
        refetchGetTemplate();
      }
    },
  });

  return {
    isLoadingDeleteTemplate,
    deleteTemplateMutation,
    dataDeleteTemplate,
  };
};

export const useChangeNameTemplate = () => {
  const { refetchGetTemplate } = useGetTemplates();

  const {
    isLoading: isLoadingChangeNameTemplate,
    mutate: changeNameTemplateMutation,
    data: dataChangeNameTemplate,
  } = useMutation('changeNameTemplate', (data: any) => templateService.changeNameTemplate(data), {
    onSuccess: () => {
      refetchGetTemplate();
    },
  });

  return {
    isLoadingChangeNameTemplate,
    changeNameTemplateMutation,
    dataChangeNameTemplate,
  };
};

export const useFilterTemplate = () => {
  const {
    isLoading: isLoadingFilterTemplate,
    mutate: filterTemplateMutation,
    data: dataFilterTemplate,
  } = useMutation('filterTemplate', (data: any) => templateService.filterTemplate(data));

  return {
    isLoadingFilterTemplate,
    dataFilterTemplate,
    filterTemplateMutation,
  };
};

export const useEditTemplate = () => {
  const {
    isLoading: isLoadingEditTemplate,
    mutate: editTemplateMutation,
    data: dataEditTemplate,
  } = useMutation('createTemplate', (data: any) => templateService.editTemplate(data));

  return {
    isLoadingEditTemplate,
    editTemplateMutation,
    dataEditTemplate,
  };
};
